import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-6 lg:p-8 bg-white rounded-lg mb-8" }
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6" }
const _hoisted_3 = { class: "col-span-full lg:col-span-6" }
const _hoisted_4 = { class: "col-span-full lg:col-span-6" }

import TextInput from '@/components/inputs/TextInput.vue';
import CalendarPicker from '@/components/CalendarPicker.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingInformation',
  props: {
    form: {
        type: Object,
        required: true
    },
    errors: {
        type: Object,
        default: () => ({})
    },
    disableInputs: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props

const item = ref(props.form)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TextInput, {
          disabled: __props.disableInputs,
          id: "patient_id",
          modelValue: item.value.patient_id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.patient_id) = $event)),
          type: "text",
          placeholder: "Patient ID / 受診者様ID"
        }, null, 8, ["disabled", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createBlock(CalendarPicker, {
          disabled: __props.disableInputs,
          key: item.value.booking_date,
          modelValue: item.value.booking_date,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.booking_date) = $event)),
          id: "date-of-examination",
          inline: false,
          placeholder: "Date of Examination(mm/dd/yyyy) / 健診日(月/日/年)"
        }, null, 8, ["disabled", "modelValue"]))
      ])
    ])
  ]))
}
}

})